import { useMemo } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import {
  bulkPublishSelectionAtom,
  clearBulkPublishSelectionAtom,
  removeFromBulkPublishSelectionAtom,
  toggleBulkPublishSelectionAtom,
} from '../store/suggestion/bulkPublish.js';

export const useBulkPublishActions = () => ({
  toggle: useSetAtom(toggleBulkPublishSelectionAtom),
  remove: useSetAtom(removeFromBulkPublishSelectionAtom),
  clear: useSetAtom(clearBulkPublishSelectionAtom),
});

export const useIsBulkPublishSelected = (id: number): boolean => {
  const isSelectedAtom = useMemo(
    () => selectAtom(bulkPublishSelectionAtom, (s) => s.has(id)),
    [id],
  );
  return useAtomValue(isSelectedAtom);
};

export const useBulkPublishSelection = () => {
  const selected = useAtomValue(bulkPublishSelectionAtom);
  const actions = useBulkPublishActions();

  const ids = useMemo(() => Array.from(selected.keys()), [selected]);
  const suggestions = useMemo(() => Array.from(selected.values()), [selected]);

  return {
    ids,
    suggestions,
    count: selected.size,
    ...actions,
  };
};
